"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * In react js making forms can be little annoying, each kind
 * of input needs to be handled differently and set it in the state.
 * Writing this logic for each field, of a generic one for each form, can be a pain in the ass.
 *
 * This class pretends to provide all generic functionality required to get the value of
 * the state and updated accordingly.
 * In case of concrete scenarios, you can always create your specific handlers
 *
 * The key is that the 'name' attribute of the input must match the state name attribute to be updated.
 * All the functions save in the state and return the updated value, in case we require to use it inmediately,
 * for example, to propaget it in a event.
 */
var React = require("react");
var _ = require("lodash");
var FormComponent = /** @class */ (function (_super) {
    __extends(FormComponent, _super);
    function FormComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Handles a normal text input
     */
    FormComponent.prototype.handleInputChange = function (event) {
        var _a;
        var target = event.target;
        this.setState((_a = {}, _a[target.name] = target.value, _a));
        return target.value;
    };
    /**
     * Handles a multiselect (Dropdwon where you can select several)
     * @return Selected options value
     */
    FormComponent.prototype.handleSelectMultiple = function (event) {
        var _a;
        var target = event.target;
        if (target.value === '') {
            return [];
        }
        var options = target.options;
        var selectedOptions = _.filter(options, function (o) { return o.selected; }).map(function (o) { return o.value; });
        this.setState((_a = {}, _a[target.name] = selectedOptions, _a));
        return selectedOptions;
    };
    /**
     * Handle Image input of single selection
     * @return Image selected
     */
    FormComponent.prototype.handleImageChange = function (event) {
        var _a;
        var target = event.target;
        this.setState((_a = {}, _a[target.name] = target.files[0], _a));
        return target.files[0];
    };
    /**
     * Handle Checkboxs
     * Checkbox groups must have same name.
     * @return List of checkbox selected of the same type
     */
    FormComponent.prototype.handleCheckBox = function (target) {
        var _a;
        var name = target.name;
        var selectedValues = __spreadArray([], this.state[name], true);
        target.checked ?
            selectedValues.push(target.value) :
            selectedValues = _.filter(selectedValues, function (id) { return id !== target.value; });
        this.setState((_a = {}, _a[name] = selectedValues, _a));
        return selectedValues;
    };
    /**
     * Select ALL, we take a check input and we select all the values.
     * @param values All the values that must be selected.
     * This function returns a second function with the values wrapepd
     */
    FormComponent.prototype.handleSelectAll = function (values) {
        var _this = this;
        return function (target) {
            var _a;
            var selectedIds = target.checked ? values : [];
            _this.setState((_a = {}, _a[target.name] = selectedIds, _a));
            return selectedIds;
        };
    };
    return FormComponent;
}(React.Component));
exports.default = FormComponent;
